import { css } from 'lit';
export const tokenBalanceAndMaxButtonStyle = css `
  :host {
    display: flex;
    gap: 4px;
    align-items: center;
  }
`;
//# sourceMappingURL=token-balance-and-max-button.style.js.map